import type { NextApiRequest, NextApiResponse } from 'next';
import { runMiddleware, validateJwt } from '../../middleware';
import { supabase } from '../../supabase';
import { Database } from '../../../../types';
import { LoyaltyRewardData } from './[id]';

export enum LoyaltyRewardType {
    MANUAL = 'manual',
    GENERAL = 'general'
}

export type LoyaltyReward = Omit<Database['public']['Tables']['loyalty_rewards']['Row'], 'data' | 'type'>  & { type: LoyaltyRewardType, unlocked: boolean, users: number, data?: LoyaltyRewardData };

export default async function getHandler(
    req: NextApiRequest,
    res: NextApiResponse<{ rewards: LoyaltyReward[] }>,
) {
    await runMiddleware(req, res, validateJwt);
    const address = req.body.jwt.address;
    const { artist } = req.query;

    const { data, error } = await supabase
        .from('loyalty_rewards')
        .select(`
      *,
      users:loyalty_reward_users(user_address)
    `)
        .eq('artist', artist)
        .order('points');

    if (error) {
        res.status(500).end();
        return;
    }

    const rewards = data
        .map(r => {
            const unlocked = !!(r.users as unknown as { user_address: string }[]).find((u) => u.user_address === address);
            return {
                ...r,
                unlocked,
                users: r.users.length,
                data: unlocked ? r.data : undefined // hide data if reward not unlocked
            } as LoyaltyReward
        });

    res.status(200).json({ rewards });
}